<template>
  <v-card class="summary-card rounded-lg mx-2 px-4 py-5" elevation="0">
    <div class="summary-card__header mb-4">
      <h2 class="summary-card__title">Summary</h2>
      <div class="summary-card__filters">
        <v-select
          filled
          rounded
          dense
          label="Sort by"
          v-model="selectedSort"
          :items="sortingOptions"
          item-text="text"
          item-value="value"
          @input="$emit('change-sort', $event)"
          class="ml-4"
          :hide-details="true"
        />
        <v-select
          filled
          rounded
          dense
          label="Filter by"
          v-model="selectedFilter"
          :items="filterOptions"
          item-text="text"
          item-value="value"
          @input="$emit('change-filter', $event)"
          class="ml-4"
          :hide-details="true"
        />
      </div>
    </div>
    <div class="summary-card__body">
      <summary-card-body-item
        :value="participants"
        :title="
          !isCompanyAdmin || hasRouteParamsID ? 'Participants' : 'Advisors'
        "
      />
      <summary-card-body-item
        :value="positiveActions"
        :title="tenantTexts.participantsDashboard.totalRoutines"
      />
      <summary-card-body-item
        :value="avgDailyRatingFormatted"
        :subValue="`${totalDailyRating} rates`"
        title="Avg. daily rating"
      />
      <summary-card-body-item
        v-if="showJournal"
        :value="journalEntries"
        title="Total Journal entries"
      />
      <summary-card-body-item
        v-if="showSwaps"
        :title="tenantTexts.participantsDashboard.totalSwaps"
      >
        <strong class="summary-card-swaps__value">{{ swapsAddedTo }}</strong>
        <span class="summary-card-swaps__subValue">Added To</span>
        <strong class="summary-card-swaps__value">{{ swapsCompleted }}</strong>
        <span class="summary-card-swaps__subValue">Completed</span>
        <strong class="summary-card-swaps__value">{{ swapsInProgress }}</strong>
        <span class="summary-card-swaps__subValue">In progress</span>
      </summary-card-body-item>
    </div>
  </v-card>
</template>

<script>
import TenantTextsMixin from '@/mixins/tenantTexts'
import SummaryCardBodyItem from './SummaryCardBodyItem.vue'
import { mapGetters, mapState } from 'vuex'
export default {
  components: { SummaryCardBodyItem },
  mixins: [TenantTextsMixin],
  name: 'SummaryCard',
  props: {
    filter: {
      type: String,
      required: true,
    },
    filterOptions: {
      type: Array,
      required: true,
      default: () => [],
    },
    sort: {
      type: String,
      required: true,
    },
    sortingOptions: {
      type: Array,
      required: true,
      default: () => [],
    },
    showSwaps: {
      type: Boolean,
      required: false,
      default: true,
    },
    showJournal: {
      type: Boolean,
      required: false,
      default: true,
    },
    participants: {
      type: Number,
      required: false,
      default: 0,
    },
    positiveActions: {
      type: Number,
      required: false,
      default: 0,
    },
    avgDailyRating: {
      type: Number,
      required: false,
      default: 0,
    },
    totalDailyRating: {
      type: Number,
      required: false,
      default: 0,
    },
    journalEntries: {
      type: Number,
      required: false,
      default: 0,
    },
    swapsAddedTo: {
      type: Number,
      required: false,
      default: 0,
    },
    swapsCompleted: {
      type: Number,
      required: false,
      default: 0,
    },
    swapsInProgress: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data: () => ({
    isLoading: false,
    selectedFilter: 'week',
    selectedSort: 'lastActivitySort',
  }),
  computed: {
    ...mapGetters('userStates', ['getRolename']),
    ...mapState('dictionariesStates', ['dictionaryPracticeUserRole']),
    avgDailyRatingFormatted() {
      return parseFloat(this.avgDailyRating).toFixed(1)
    },
    isCompanyAdmin() {
      return (
        this.dictionaryPracticeUserRole[this.getRolename] ===
        this.dictionaryPracticeUserRole.Administrator
      )
    },
    hasRouteParamsID() {
      return this.$route.params.id
    },
  },
  methods: {},
  watch: {
    selectedFilter(val, prev) {
      console.log({ selectedFilter: val, prev })
    },
    selectedSort(val, prev) {
      console.log({ selectedSort: val, prev })
    },
    sort(val) {
      if (val) this.selectedSort = val
    },
    filter(val) {
      if (val) this.selectedFilter = val
    },
  },
}
</script>

<style lang="scss">
.summary-card {
  min-width: 800px;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__title {
    color: $bh-black;
    font-size: 14px;
    line-height: 20px;
  }
  &__body {
    display: flex;
    margin: -0.5 * $gutter;

    .summary-card-body-item {
      padding: 0.5 * $gutter;
      flex: 1;

      &:last-of-type {
        flex: initial;
      }
    }
  }
  &__filters {
    display: flex;
    align-items: center;
  }
}
</style>
